import { configureStore } from '@reduxjs/toolkit';

import channelReducer from './channelSlice';
import fileDownloadSlice from './fileDownloadSlice';

export const store = configureStore({
  reducer: {
    channel: channelReducer,
    fileDownload: fileDownloadSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
